import 'choices.js/public/assets/styles/choices.min.css';
import Choices from 'choices.js';
import arraySort from 'array-sort';

function initSearch (container) {
  const searchElement = container.querySelector('.drivers__search');
  const searchForm = container.querySelector('.drivers__form');
  const districtElement = container.querySelector('.drivers__district');
  const buttonElement = container.querySelector('.drivers__search-button');
  const tableElement = container.querySelector('.drivers__overflow-table');
  const noresultsElement = container.querySelector('.drivers__no-results');

  // eslint-disable-next-line no-new
  const choices = new Choices(districtElement, {
    searchEnabled: false,
    itemSelectText: '',
  });

  districtElement.addEventListener('change',
    (event) => {
      const disabled = event.detail.value.length > 0;
      searchElement.disabled = disabled;
      districtElement.disabled = false;
    },
    false
  );

  searchElement.addEventListener(
    'input',
    (event) => {
      const disabled = event.target.value.length > 0;
      if (disabled) {
        choices.disable();
      } else {
        choices.enable();
      }
      searchElement.disabled = false;
    },
    false
  );

  searchForm.addEventListener(
    'submit',
    (event) => {
      event.preventDefault();
      search();
    },
    false
  );

  let drivers = [];
  async function search () {
    buttonElement.classList.add('drivers__loading');
    if (drivers.length < 1) {
      const source = await fetch('/!/Fetch/collection/drivers');
      const sourceJson = await source.json();
      let loadedDrivers = sourceJson.data;
      loadedDrivers.map(driver => {
        driver.districtTitle = driver.district && driver.district[0] && driver.district[0].title;
        driver.locationTitle = driver.location && driver.location[0] && driver.location[0].title;
        driver.districtSlug = driver.district && driver.district[0] && driver.district[0].slug;
      });

      drivers = arraySort(loadedDrivers, ['location_raw', 'title']);
    }
    noresultsElement.classList.add('drivers__hidden');

    let filteredDrivers = drivers;
    if (searchElement.value.length > 0) {
      const searhText = searchElement.value.toLowerCase();
      filteredDrivers = drivers.filter((driver) => filterBySearch(driver, searhText));
    } else if (districtElement.value.length > 0) {
      filteredDrivers = drivers.filter(driver => driver.district[0].slug === districtElement.value);
    }

    buttonElement.classList.remove('drivers__loading');

    if (filteredDrivers.length === 0) {
      tableElement.classList.add('drivers__hidden');
      noresultsElement.classList.remove('drivers__hidden');

      return filteredDrivers;
    }

    const itemsHtml = filteredDrivers.reduce((acc, item) => {
      acc += generateHtmlItem(item);
      return acc;
    }, '');
    tableElement.querySelector('tbody').innerHTML = itemsHtml;
    tableElement.classList.remove('drivers__hidden');
  }

  function generateHtmlItem (item) {
    const taxi = item.taxi ? '<span class="drivers__mark"></span>' : '';
    const wheelchair = item.wheelchair ? '<span class="drivers__mark"></span>' : '';
    const phones = item.phone.reduce((accumulator, phone) => {
      const hrefPhone = 'tel:' + phone.replace(/[^0-9]/g, '');
      return accumulator + `<a class="drivers__phone" href="${hrefPhone}">${phone}</a>`;
    }, '');

    return `
      <tr>
        <td>${item.district[0].title}</td>
        <td>${item.location[0].title}</td>
        <td>${phones}</td>
        <td>${item.title}</td>
        <td>${taxi}</td>
        <td>${wheelchair}</td>
      </tr>
    `;
  }

  function filterBySearch (item, searhText) {
    const driverText = `${item.districtTitle} ${item.locationTitle} ${item.phone.join(', ')} ${item.title}`.toLowerCase();
    return driverText.indexOf(searhText) !== -1;
  }

  buttonElement.addEventListener('click', search);
}

export default function () {
  document.querySelectorAll('.drivers').forEach(initSearch);
}
